export enum enumCompanyBusinessType {
  LLC = 1,
  PARTNERSHIP = 2,
  SOLE_PROPRIETOR = 3,
  CORPORATION = 4,
  INDIVIDUAL = 5,
}
